import React, { createContext, useReducer } from 'react'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case 'set_connector_data': {
      return { ...data, data: payload.data }
    }
    case 'update_change_connector': {
      let tempData = [...data.data]
      tempData[payload.data.index] = payload.data
      return { ...data, data: tempData }
    }
    case 'set_selected_connector': {
      return { ...data, selectedConnector: payload.data }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: [],
  selectedConnector: {},
}

const ConnectorStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <ConnectorContext.Provider value={[state, dispatch]}>
      {children}
    </ConnectorContext.Provider>
  )
}

export const ConnectorContext = createContext(initialState)
export default ConnectorStore
